export const IOS_DEFAULT_DISCOVERY_REQUEST_CONFIG = {
  initialShelfCount: 20,
  subsequentShelfCount: 20,
  shouldFlushOnAppLoad: true,
};

export const ANDROID_DEFAULT_DISCOVERY_REQUEST_CONFIG = {
  initialShelfCount: 10,
  subsequentShelfCount: 10,
  shouldFlushOnAppLoad: true,
};
